import axios from 'axios';
import {backendHost} from '../../config';

export const getPaymentsMethod = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/wallet`, {params});
};